import { api } from './client';

// ============================================
// Types
// ============================================

export interface TtInsightRow {
  stat_time_day: string;
  advertiser_id?: string;
  account_name?: string;
  dimension_value?: string;

  // additive (SUM)
  spend: number;
  impressions: number;
  clicks: number;
  reach: number;
  conversion: number;
  complete_payment: number;
  conversion_value: number;
  total_purchase: number;
  total_purchase_value: number;
  onsite_shopping: number;
  initiate_checkout: number;
  onsite_initiate_checkout_count: number;
  total_initiate_checkout_value: number;
  registration: number;
  result: number;
  cta_purchase: number;
  cta_purchase_value: number;
  likes: number;
  comments: number;
  shares: number;
  follows: number;
  profile_visits: number;
  video_play_actions: number;
  video_watched_2s: number;
  video_watched_6s: number;
  video_views_p25: number;
  video_views_p50: number;
  video_views_p75: number;
  video_views_p100: number;

  // ratio (calculated)
  ctr: number;
  cpc: number;
  cpm: number;
  frequency: number;
  complete_payment_roas: number;
  cost_per_complete_payment: number;
  cost_per_purchase: number;
  value_per_complete_payment: number;
  cost_per_onsite_shopping: number;
  cost_per_registration: number;
  cost_per_result: number;
  result_rate: number;
  cta_cost_per_purchase: number;
  average_video_play: number;
  average_video_play_per_user: number;
}

export interface TtInsightListParams {
  brand_id: string;
  site_id?: string;
  start_date: string;
  end_date: string;
  advertiser_ids?: string;
  dimension?: string;
  ad_id?: string;
  ad_name?: string;
  campaign_name?: string;
  adgroup_name?: string;
  funnel_level?: string;
  customer_type?: string;
  channel_tier?: string;
  ad_form?: string;
  material_type?: string;
  optimize_target?: string;
  catalog_type?: string;
  price_range?: string;
  targeting_type?: string;
  audience_group?: string;
  customer_segment?: string;
  landing_page?: string;
  fields?: string;
  page?: number;
  size?: number;
}

export interface TtInsightListResponse {
  code: number;
  message: string;
  data: {
    list: TtInsightRow[];
    total: number;
    page: number;
    size: number;
    total_page: number;
    summary: TtInsightRow | null;
  };
}

export interface AccountOption {
  account_id: string;
  account_name: string;
}

export interface DimensionOption {
  value: string;
  label: string;
}

// ============================================
// API
// ============================================

export const ttInsightsApi = {
  getList: (params: TtInsightListParams) =>
    api.get<TtInsightListResponse>('/tt-insights/list', { params }),

  getAccounts: (params: { brand_id: string; site_id?: string; scope?: 'dashboard_read' | 'dashboard_export' }) =>
    api.get<{ code: number; data: AccountOption[] }>('/tt-insights/accounts', { params }),

  getDimensions: () =>
    api.get<{ code: number; data: DimensionOption[] }>('/tt-insights/dimensions'),
};
